import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { WaybillIdView } from '../../../../models';
import {
  ShipmentWaybillTrackingMapInitialState,
  ShipmentWaybillTrackingMapLoad,
} from './shipment-waybill-tracking-map.actions';
import { ShipmentWaybillTrackingMapState } from './shipment-waybill-tracking-map.state';
import { ShipmentWaybillMapData } from '../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillTrackingMapFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentWaybillTrackingMapState.getLoaded);
  mapData$: Observable<ShipmentWaybillMapData> = this.store.select(ShipmentWaybillTrackingMapState.getMapData);

  constructor(private store: Store) {}

  loadAll(identifier: WaybillIdView): void {
    this.store.dispatch(new ShipmentWaybillTrackingMapLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentWaybillTrackingMapInitialState());
  }
}
